import type { ReactNode } from "react";
import { Row } from "@hightouch/htui";

import { MEDIA_DETAIL_SPLIT_QUERY } from "src/components/media-detail/constants";

type Props = {
  /** Omit when there is nothing to show. */
  children?: ReactNode;
};

/**
 * The preview. Fills the row beside the details, or a fixed frame above them.
 * With no children it renders nothing when stacked, rather than an empty frame.
 */
export function MediaDetailMedia({ children }: Props) {
  const isEmpty = children === undefined || children === null;

  return (
    <Row
      display={isEmpty ? "none" : "flex"}
      flexShrink={0}
      minW={0}
      h="320px"
      align="center"
      justify="center"
      overflow="hidden"
      borderRadius="lg"
      bg="base.lightBackground"
      sx={{
        [MEDIA_DETAIL_SPLIT_QUERY]: {
          display: "flex",
          flex: 1,
          h: "100%",
          p: 8,
          borderRadius: 0,
          bg: "transparent",
        },
      }}
    >
      {children}
    </Row>
  );
}
